import { Plus } from 'lucide-react';
import type { Ref } from 'react';

interface MarketingNoteListHeaderProps {
  title: string;
  count: number | null;
  /** The count in words, for assistive tech. */
  countLabel: (count: number) => string;
  /** The add button's label, or null when the caller cannot add. */
  addLabel: string | null;
  /** Lets the owner return focus to the add button after the composer closes. */
  addButtonRef?: Ref<HTMLButtonElement>;
  onAdd: () => void;
}

/** Heading of one list, with how many it holds and an add button. */
export function MarketingNoteListHeader({
  title,
  count,
  countLabel,
  addLabel,
  addButtonRef,
  onAdd,
}: MarketingNoteListHeaderProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        paddingBottom: 6,
        borderBottom: '1px solid var(--nb-border)',
      }}
    >
      <h4 className="nb-display" style={{ margin: 0, fontSize: 13, letterSpacing: '.04em' }}>
        {title}
      </h4>
      {count !== null && (
        <span
          className="nb-pill"
          aria-label={countLabel(count)}
          style={{ height: 18, fontSize: 10, padding: '0 7px', fontWeight: 700 }}
        >
          {count}
        </span>
      )}
      <span style={{ flex: 1 }} />
      {addLabel && (
        <button
          type="button"
          ref={addButtonRef}
          className="nb-btn nb-btn-ghost"
          onClick={onAdd}
          style={{ height: 22, fontSize: 11, padding: '0 8px' }}
        >
          <Plus size={11} aria-hidden="true" />
          {addLabel}
        </button>
      )}
    </div>
  );
}
